import React from "react";
import Dropdown from "./Dropdown";
export default (function (domNode) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var readData = function readData(prop) {
    var data = domNode.getAttribute("data-".concat(prop));
    return data ? JSON.parse(data) : null;
  }; // NB you can't and shouldn't ever need to rehydrate functions


  var props = {
    isRehydrating: true,
    block: readData("block"),
    items: readData("items"),
    placeholder: readData("placeholder"),
    size: readData("size"),
    value: readData("value")
  };
  return Promise.resolve( /*#__PURE__*/React.createElement(Dropdown, props));
});